import React, { Fragment, useRef } from "react";
import PropTypes from "prop-types";
import { Box, Pressable } from "native-base";

function FilePicker(props) {
  const { children, accept, multiple, onSelect, disabled } = props;
  const fileInput = useRef();

  return (
    <Fragment>
      <Box display="none">
        <input
          type="file"
          multiple={multiple}
          accept={accept}
          ref={fileInput}
          onChange={(e) => {
            if (e.target.files.length > 0) {
              onSelect(e.target.files);
            }
            e.target.value = "";
          }}
        />
      </Box>
      <Pressable onPress={() => fileInput.current.click()} disabled={disabled}>
        {children}
      </Pressable>
    </Fragment>
  );
}

FilePicker.propTypes = {
  children: PropTypes.any.isRequired,
  onSelect: PropTypes.func.isRequired,
  accept: PropTypes.string,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
};

FilePicker.defaultProps = {
  accept: "",
  multiple: false,
  disabled: false,
};

export default React.memo(FilePicker);
